import PropTypes from 'prop-types';

function MMOurBrandsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47771)">
                <path
                    d="M13.4516 1.05336L3.9345 9.74974C3.38837 10.2488 3.3502 11.096 3.84923 11.6422L16.2006 25.1591C16.6996 25.7053 17.5469 25.7435 18.093 25.2444L27.6101 16.548C28.1562 16.049 28.1944 15.2017 27.6954 14.6556L15.344 1.13863C14.845 0.592501 13.9977 0.554323 13.4516 1.05336Z"
                    fill="#F1EAD0"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.3815 1.36472L10.2616 5.75922C9.56615 6.01139 9.20678 6.77962 9.45895 7.47511L15.7004 24.6887C15.9526 25.3842 16.7208 25.7436 17.4163 25.4914L29.5361 21.0969C30.2316 20.8447 30.591 20.0765 30.3388 19.381L24.0974 2.16741C23.8452 1.47192 23.077 1.11255 22.3815 1.36472Z"
                    fill="#F1EAD0"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M31.2777 5.32027L18.4147 4.4569C17.6766 4.40735 17.038 4.96556 16.9885 5.70369L15.7622 23.9728C15.7127 24.7109 16.2709 25.3495 17.009 25.399L29.872 26.2624C30.6101 26.3119 31.2487 25.7537 31.2982 25.0156L32.5245 6.74649C32.574 6.00836 32.0158 5.36982 31.2777 5.32027Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M24.1055 13.2184C23.8327 12.8605 23.4854 12.1376 22.4258 12.2332C21.3698 12.3254 20.4201 13.2751 20.4874 14.4658C20.5547 15.66 21.2068 16.7266 22.0714 17.5311C22.9361 18.3355 23.574 18.7146 23.8645 18.8032C24.1658 18.7288 25.8384 17.9138 26.5755 16.9995C27.3161 16.0817 28.0674 15.3517 27.6173 13.7216C27.1673 12.0915 25.2289 12.414 24.9879 12.6266C24.7469 12.8392 24.1055 13.2149 24.1055 13.2149V13.2184Z"
                    fill="#DB6C31"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47771">
                    <rect width="35.4794" height="29.5224" fill="white" transform="translate(0.901428 0.351562)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMOurBrandsActive;

MMOurBrandsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMOurBrandsActive.defaultProps = {
    className: null,
    width: 28,
};
